export interface Category {
  id: number;
  nameKey: string;
  url: string;
}

export const categories: Category[] = [
  { id: 911, nameKey: "categories.shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { id: 912, nameKey: "categories.hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { id: 913, nameKey: "categories.tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { id: 914, nameKey: "categories.jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { id: 915, nameKey: "categories.pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { id: 916, nameKey: "categories.headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { id: 917, nameKey: "categories.sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { id: 918, nameKey: "categories.underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { id: 919, nameKey: "categories.jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { id: 920, nameKey: "categories.accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { id: 921, nameKey: "categories.bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { id: 922, nameKey: "categories.belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { id: 923, nameKey: "categories.perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { id: 924, nameKey: "categories.other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];